import type { ScopePhase, ScopePhaseStatus } from '../hooks/useScopeStream';

const PHASE_ORDER: ScopePhase[] = ['auth', 'navigator', 'extractor', 'preflight', 'canary'];
const PHASE_LABELS: Record<ScopePhase, string> = {
  auth: 'Authenticate',
  navigator: 'Explore',
  extractor: 'Extract',
  preflight: 'Validate',
  canary: 'Canary',
};

export interface StepPipelineProps {
  phases: Record<ScopePhase, ScopePhaseStatus>;
}

function statusClass(status: ScopePhaseStatus): string {
  switch (status) {
    case 'pending': return 'bg-slate-700 text-slate-400';
    case 'started': return 'bg-blue-600 text-white animate-pulse';
    case 'completed': return 'bg-emerald-600 text-white';
    case 'failed': return 'bg-rose-600 text-white';
  }
}

export function StepPipeline({ phases }: StepPipelineProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {PHASE_ORDER.map((phase, idx) => {
        const status = phases[phase] ?? 'pending';
        return (
          <div key={phase} className="flex items-center gap-2">
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${statusClass(status)}`}>
              {PHASE_LABELS[phase]}
              {status === 'completed' && ' ✓'}
              {status === 'failed' && ' ✗'}
            </span>
            {idx < PHASE_ORDER.length - 1 && <span className="text-slate-600">→</span>}
          </div>
        );
      })}
    </div>
  );
}
